<!--
 * @Description: 月龄+搜索 公共组件
 * @props className 给组件设置样式的类名
 * @props selsct 当前选中的标签，默认全部
 * @props inputPlaceholder 搜索底文,默认显示，“开始搜索，从新妈变星妈”
 * @props isBackHander 是否显示返回按钮，默认显示
 * @props backHander 返回执行的方法，调用者自定，不做统一处理
 * @props inputFocusHander 输入框获取焦点时执行的方法，调用者自定，不做统一处理
 * @props changeParentData 将选中的标签数据传给父级，调用者自定，不做统一处理
 * @Author: taoyan
 * @Email: taoyan_work@163.com
 * @Date: 2022-03-14 16:13:22
 * @LastEditTime: 2022-06-21 10:17:44
 * @LastEditors: Please set LastEditors
 *this.$refs.monthSearchref.closeOption() 来关闭这个选项卡
-->
<!--
调用举例
<month-search
  className="foodColumn"
  :select="select"
  :inputPlaceholder="'开始搜索，从新妈变星妈'"
  :isBackHander="isBackHander"
  @backHander="backHander"
  @inputFocusHander="searchHander"
  @changeParentData="getDataByTag">
</month-search>
-->

<template>
  <div class="month_search" :class="className">
    <div class="search_">
      <div v-if="!hideBackButton" class="search-backicon">
          <span class="goback-background" @click.stop="backHander"></span>
        </div>
      <!-- <div class="back" @click.stop="backHander">
        <van-icon name="arrow-left" />
      </div> -->
      <div class="selector-input">
        <div class="selector-item" :class="isShowTagList && 'route-arrow'" @click.stop="showHander">
          <span>{{ currentSelect }}</span>
          <img src="../../../assets/images/icon/arrow_1.png" />
        </div>
        <form action="javascript:return true" style="flex: 1">
          <van-search
            :left-icon="require('../../../assets/images/icon/new_search.png')"
            class="vanSearch"
            :placeholder="inputPlaceholder"
            shape="round"
            @focus="inputFocusHander"
          />
        </form>
      </div>
    </div>
    <!-- 下拉选项 -->
    <div class="selector-down">
      <div class="triangle"></div>
      <ul class="option">
        <li
          v-for="item in optionList"
          :key="item.id"
          @click.stop="seletHander(item.name, item.id)"
          v-bind:class="{ 'active': currentSelect == item.name }"
        >
          {{ item.name }}
        </li>
      </ul>
    </div>
  </div>
</template>
<style lang="less">
.month_search {
  padding: 13px 0 11px;
  width: 100%;
  height: 42px;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 98;
  // overflow: hidden;
  //搜索框
  .search_ {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 16px 0 12px;

    .search-backicon {
      width: 10px;
      height: 18px;
      margin-right: 12px;
      .goback-background {
        display: block;
        width: 100%;
        height: 100%;
        background-image: url("../../../assets/images/home/search-back.png");
        background-size: 100% 100%;
        background-position: center;
      }
    }

    // .back {
    //   font-size: @indexFontSize18;
    //   height: 18px;
    // }
    .selector-input {
      display: flex;
      flex: 1;
      justify-content: space-between;
      align-items: center;
      padding: 6px 12px 6px 10px;
      background: @expertFontColor255;
      border-radius: 21px;
      border: 2px solid #fff;

      .selector-item {
        display: flex;
        align-items: center;
        height: 26px;
        padding-right: 12px;
        border-right: 1px solid #d0d0d0;
        span {
          font-size: 14px;
          color: #555;
          line-height: 26px;
          margin-right: 4px;
        }
        img {
          width: 7px;
          height: 5px;
        }
      }
      .vanSearch{
        .van-icon{
          font-size: 20px;
        }

      }
      .route-arrow{
        img{
          transform: rotate(180deg);
        }
      }

      .van-search {
        flex: 1;
        height: 26px;
        padding: 0;
        font-size: @indexFontSize13;
        .van-search__content {
          padding-left: 12px;
          background: none;
          .van-cell{
            padding: 0;
          }
        }
        .van-search__action {
          font-size: @indexFontSize14;
        }
        .van-field__control {
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          padding-left: 2px;
          color: #999;
        }
      }
    }
  }
  //选项
  .selector-down {
    position: fixed;
    top: 55px;
    left: 0;
    z-index: 2;
    text-align: center;
    display: none;
    .triangle {
      width: 0;
      height: 0;
      border: 5px solid transparent; //所有border都是透明的，
      border-bottom-color: #FF67C1; //只有尖相对的方向border有颜色
      position: fixed;
      left: 53px;
    }
    .option {
      padding-top: 10px;
      width: 116px;
      background: @expertFontColor255;
      box-shadow: 1px 3px 3px 0px rgba(142, 142, 142, 0.2);
      line-height: 39px;
      font-size: @indexFontSize14;
      .active {
        color: #FF67C1;
      }
    }
  }
}
</style>
<script>
import { Toast } from "vant";
import { isFromMiniprogram } from "@/assets/js/common.js";
export default {
  name: "month-search",
  props: {
    className: {
      type: String,
      default: "",
    },
    select: {
      type: String,
      default: "全部",
    },
    inputPlaceholder: {
      type: String,
      default: "开始搜索",
    },
  },
  data() {
    return {
      isShowTagList: false, //控制月龄标签选项显示隐藏
      currentSelect: "全部",
      optionList: [], //月龄标签选项列表
    };
  },
  watch: {
    select: {
      handler(val) {
        console.log('当前月龄段',val);
        this.currentSelect = val;
      },
      immediate: true,
    },
  },
  computed: {
    // 小程序来源页面隐藏返回按钮，避免与小程序原生导航返回冲突
    hideBackButton() {
      return isFromMiniprogram(this.$route);
    },
  },
  created(){
    // 点击任何地方关闭选项列表
    document.addEventListener('click',this.closeOption)
  },
  mounted() {
    this.getMonthsPeriod();
  },
  methods: {
    // 获取月龄段
    getMonthsPeriod() {
      this.$http.get("/babyWikiRevision/monthsPeriod", {}, (res) => {
        if (res.code === "200") {
          this.optionList = [{ name: "全部", id: 0 }];
          for (var i = 0; i < res.data.length; i++) {
            if (res.data[i].id > 0 && res.data[i].id < 7) {
              this.optionList.push(res.data[i]);
            }
          }
          // 月龄获取完毕
          this.$emit("endMonthsAge")
        } else {
          Toast({
            message: res.message,
            duration: 2000,
          });
        }
      });
    },
    // 选择月龄标签
    showHander(e) {
      this.isShowTagList = !this.isShowTagList;
      if (this.isShowTagList) {
        $(".selector-down").slideDown();
      } else {
        $(".selector-down").slideUp();
      }
    },
    closeOption(){
      this.isShowTagList = false;
      $(".selector-down").slideUp();
    },
    //点击月龄选项
    seletHander(option, id) {
      this.isShowTagList = !this.isShowTagList;
      this.currentSelect = option;
      sensors.track("ExchangeAge", {
        age_interval: this.currentSelect,
      });
      $(".selector-down").slideUp();
      // 根据当前选中的月龄段获取标签列表
      this.$emit("changeParentData", option, id, false);
    },
    // 点击返回触发的方法
    backHander() {
      this.$emit("backHander");
    },
    // 搜索框获取焦点触发的方法
    inputFocusHander() {
      this.$emit("inputFocusHander");
    },
  },
};
</script>